<template>
  <div class="custom-margin-full-page pa-2">
    <v-row v-for="notif in notifications.data" :key="notif.id" class=" my-2 v-row-customized"
           :style="'border-color:'+notif.color">
      <v-col cols="1">
        <v-icon color="black"
                v-if="notif.section === 'general' && !notif.type && !notif.attachment_type">
          mdi-bell
        </v-icon>
        <v-icon color="black" v-if="notif.type === 'lesson_unlocked'">mdi-lock-open-variant-outline</v-icon>
        <v-icon color="black" v-if="notif.type === 'lesson_locked'">mdi-lock-outline</v-icon>
        <v-icon color="black" v-if="notif.type === 'lesson_chat_audio'">mdi-microphone</v-icon>
        <v-icon color="black" v-if="notif.type === 'lesson_chat_text'">mdi-message-text</v-icon>
        <v-icon color="black" v-if="notif.section === 'concert'">mdi-account-group-outline</v-icon>
        <v-icon color="black" v-if="notif.section === 'change_program'">mdi-swap-horizontal</v-icon>
        <v-icon color="black" v-if="notif.section === 'news'">mdi-newspaper-variant-outline</v-icon>
        <v-icon color="black" v-if="notif.section === 'offer'">mdi-information-variant</v-icon>
        <v-icon color="black" v-if="notif.section === 'general' && notif.attachment_type === 'video'">mdi-video</v-icon>
        <v-icon color="black" v-if="notif.section === 'general' && notif.attachment_type === 'image'">mdi-image</v-icon>
        <v-icon color="black"
                v-if="notif.section === 'general' && notif.attachment_type !== 'video' &&  notif.attachment_type !== 'image' && notif.attachment_type && !notif.type "
        >
          mdi-paperclip
        </v-icon>
      </v-col>
      <v-col cols="9" class="mt-1" style="font-size: 12px">
        {{ notif.title }}
      </v-col>
      <v-col cols="2" @click="show(notif.id)">
        <v-icon color="#1ab69d">mdi-eye</v-icon>
      </v-col>
    </v-row>
    <v-row class="mb-16">
      <v-col cols="12" class="mb-16">
        <v-pagination
            class="text-center"
            color="#1ab69d"
            v-model="notifications.current_page"
            :length="notifications.last_page"
            circle
            @input="getNotifications"
        ></v-pagination>
      </v-col>
    </v-row>
    <v-dialog v-if="notification" v-model="showSingleNotificationDialog" max-width="100vw">
      <v-card class="ma-0">
        <v-row class="px-2 ma-0">
          <v-col cols="12">
            {{ notification.title }}
          </v-col>
          <v-col cols="12" v-if="notification.content">
            {{ notification.content }}
          </v-col>
          <v-col cols="12" v-if="notification.attachment_type === 'image'">
            <img width="100%" :src="notification.url" :alt="notification.title">
          </v-col>
          <v-col cols="12" v-if="notification.attachment_type === 'video'">
            <video width="100%" controls :src="notification.url" :alt="notification.title">
            </video>
          </v-col>
          <v-col cols="12">
            <div style="font-size:11px" v-if="notification.created_at_fa">
              ارسال شده در {{ notification.created_at_fa }} <br>
            </div>
            <div style="font-size:11px" v-if="notification.seen_at_fa">
              دیده شده در {{ notification.seen_at_fa }} <br>
            </div>
          </v-col>
          <v-col :cols="notification.url && !notification.attachment_type ? 6 : 12" class="text-center">
            <v-btn style="letter-spacing: normal" color="error" @click="showSingleNotificationDialog = false">
              بستن
            </v-btn>
          </v-col>
          <v-col
              v-if="notification.url && !notification.attachment_type"
              cols="6" class="text-center">
            <v-btn style="letter-spacing: normal" color="#1ab69d" class="white--text" @click="redirectToNotification()">
              مشاهده
            </v-btn>
          </v-col>

        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NotificationsMobile",
  data() {
    return {
      showSingleNotificationDialog: false,
      notifications: {
        current_page: 1
      },
      notification: null,
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'عنوان', value: 'title', align: 'center'},
        {text: 'محتوا', value: 'content', align: 'center'},
        {text: 'نام مربی', value: 'instructor_name', align: 'center'},
        {text: 'نام مدیر', value: 'admin_name', align: 'center'},
        {text: 'ضرورت', value: 'priority', align: 'center'},
        {text: 'بخش', value: 'section', align: 'center'},
        {text: 'دارای ضمیمه', value: 'has_attachment', align: 'center'},
        {text: 'نوع ضمیمه', value: 'attachment_type', align: 'center'},
        {text: 'لینک', value: 'url', align: 'center'},
        {text: 'ارسال شده در', value: 'created_at_fa', align: 'center'},
        {text: 'دیده شده در', value: 'seen_at_fa', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  methods: {
    openLink(url) {
      window.open(
          url, "_blank");
    },
    getNotifications() {
      let url = 'student/notification/index/all?page=' + this.notifications.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.notifications = res.data.data
      })
    },
    show(id) {
      window.axios.get('student/notification/get/' + id).then((res) => {
        this.notification = res.data.data
        this.showSingleNotificationDialog = true
        this.getNotifications()
      })
    },
    redirectToNotification() {
      this.showSingleNotificationDialog = false
      console.log(this.notification)
      this.$router.push(this.notification.url)
    },
  },
  mounted() {
    this.getNotifications()
  }
}
</script>

<style scoped>
.custom-margin-full-page {
  margin: 5vh 2vw 0 2vw;
}

.v-row-customized {
  border-style: solid;
  border-radius: 8px;
}
</style>